// «Текст постановления» («Текст определения») под пунктом ответа по праву со ссылкой на решение Конституционного Суда:
// о чём дело, что Суд постановил или определил, весь текст из базы Правосвода и ссылка на официальный текст
// (GET /api/practice/<id>). Загружается только при раскрытии; вид решения — по подписи источника.
import { useState } from "react";
import { getJson } from "../api";

type Decision = {
  id: string; label: string; title: string; subject: string; status: string; checked: string;
  url: string; resolution: string; text: string;
};

export function isDecision(sourceId: string | undefined): boolean {
  return !!sourceId && sourceId.startsWith("ks:");
}

export function DecisionText({ id, label }: { id: string; label: string }) {
  const ruling = label.startsWith("Определение");
  const [decision, setDecision] = useState<Decision | null>(null);
  const [error, setError] = useState("");
  function load(open: boolean) {
    if (!open || decision || error) return;
    getJson<Decision>(`/api/practice/${encodeURIComponent(id)}`).then(setDecision).catch((failure) => setError((failure as Error).message));
  }
  return (
    <details className="assistant-article" onToggle={(event) => load((event.currentTarget as HTMLDetailsElement).open)}>
      <summary>{ruling ? "Текст определения" : "Текст постановления"}</summary>
      {error ? <p className="msg-error">{error}</p> : !decision ? <p className="msg-hint">Загружаю…</p> : (
        <>
          <p className="decision-subject">{decision.subject.charAt(0).toUpperCase() + decision.subject.slice(1)}</p>
          <p className="msg-hint">{ruling ? "Определил:" : "Постановил:"}</p>
          <blockquote>{decision.resolution}</blockquote>
          <details className="decision-full">
            <summary>{ruling ? "Весь текст определения" : "Весь текст постановления"}</summary>
            <blockquote>{decision.text}</blockquote>
          </details>
          <p className="msg-hint">
            {decision.title}. {decision.status ? `${decision.status}. ` : ""}Сверено {decision.checked}.{" "}
            <a href={decision.url} target="_blank" rel="noreferrer">Официальный текст</a>
          </p>
        </>
      )}
    </details>
  );
}
